import Link from "next/link";
import React, { useRef } from "react";
import IndividualInsightsFirstSectionInner from "./IndividualInsightsFirstSectionInner";
import ContactUsModal from "@/components/Modal/ContactUs";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import TwitterIcon from "@mui/icons-material/Twitter";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import FacebookRoundedIcon from "@mui/icons-material/FacebookRounded";
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from "react-share";
import { useRouter } from "next/router";
import { WHATSAPP_CONTACT_LINK } from "@/utils/Common";

const IndiividualInsightsFirstSection = ({
  data,
  page,
  similarMarketInsights,
}) => {
  const renderHTML = (htmlString) => {
    return { __html: htmlString };
  };

  const router = useRouter();
  const contactUsModalRef = useRef();
  const options = [
    {
      id: "1",
      label: "Chemical Sourcing Inquiry",
    },
    {
      id: "2",
      label: "Custom Manufacturing requirements",
    },
    {
      id: "3",
      label: "Request a Elixir demo",
    },
    {
      id: "4",
      label: "Interest in joining the team",
    },
    {
      id: "5",
      label: "Interested in other partnership",
    },
  ];
  return (
    <>
      <div className="h-[40vh] md:h-[50vh] border-2 relative bg-slate-500">
        <img
          src={data?.thumbnailImgUrl}
          alt={`Image ${options.label}`}
          className="w-full h-full object-cover"
        />
        <div className="absolute top-0 w-full h-full flex justify-center items-center z-10 bg-[#00000099]">
          <p className="absolute top-4 left-2 sm:top-10 sm:left-20">
            <Link
              href={"/"}
              className="text-[0.85rem] text-[#dfdfdf] font-medium"
            >
              Home
            </Link>{" "}
            <span className="px-1 text-[#dfdfdf]">/</span>{" "}
            <Link
              href={`/${
                data?.type !== "market insights"
                  ? data?.type
                  : "market-insights"
              }`}
              className="text-[0.85rem] text-[#dfdfdf] font-medium"
            >
              {page}
            </Link>
            <span className="px-1 text-white">/</span>{" "}
            <span className="font-medium text-[0.9rem] text-white">
              {data?.title.slice(0, 20) + "..."}
            </span>
          </p>
          <div className=" w-[90%] sm:w-[40%] ">
            <h1 className="text-[1.4rem] sm:text-[2.2rem] text-center text-white  font-mukta ">
              {data?.title}
            </h1>
            <ContactUsModal
              heading={"Contact Us"}
              options={options}
              ref={contactUsModalRef}
              subHeading={"Fill in the details required to get the sample."}
              title={"Book A Demo"}
              classes={"bg-white text-red  py-2 px-3 rounded-[2px]"}
            />
            {data?.type == "events" && data?.is_upcoming && (
              <div className="w-full  flex justify-center gap-6 mt-6">
                <a
                  className="bg-red text-white py-2 px-3 rounded-[2px] hover:text-white"
                  href="https://calendly.com/elchemy/team"
                  target="_blank"
                >
                  {" "}
                  Book A Meeting
                </a>

                <button
                  onClick={() => contactUsModalRef?.current?.setOpen(true)}
                  className="bg-white text-red  py-2 px-3 rounded-[2px]"
                >
                  <div>Contact Us</div>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="py-10 mt-8 flex flex-col sm:flex-row justify-between px-8 sm:14 md:px-24">
        <div className="md:w-[30%]">
          <IndividualInsightsFirstSectionInner
            data={data}
            similarMarketInsights={similarMarketInsights}
          />
        </div>
        <div className="md:w-[65%]">
          {data?.section?.map((e) => {
            return (
              <>
                {e?.sectionHeading && (
                  <p className="text-[1rem] md:text-[1.2rem] mb-2 md:mb-6 mt-10 md:mt-0 font-medium">
                    {e?.sectionHeading}
                  </p>
                )}
                <div
                  suppressHydrationWarning={true}
                  className="mb-12 md:leading-8 text-[#666666]"
                  dangerouslySetInnerHTML={renderHTML(e?.sectionText)}
                />

                {e?.sectionImages ? (
                  <div className="flex flex-wrap w-full gap-2 mb-6 ">
                    {e?.sectionImages?.map((data) => {
                      return (
                        <>
                          {data?.imageURl && (
                            <img
                              src={data?.imageURl}
                              alt={`${options.label} image`}
                              className="w-[100%] sm:w-[48%]"
                            />
                          )}
                        </>
                      );
                    })}
                  </div>
                ) : (
                  <div className="flex flex-wrap w-full gap-2 mb-6 ">
                    {e?.sectionImage && (
                      <img
                        src={e?.sectionImage}
                        alt={`${options.label} image`}
                        className="w-[100%] sm:w-[48%]"
                      />
                    )}
                  </div>
                )}
              </>
            );
          })}
          <div className="border-t-2 pt-6 md:pt-10 flex justify-end gap-3">
            {/*<a
              href={WHATSAPP_CONTACT_LINK}
              target="_blank"
            >
              <WhatsAppIcon className="text-[#808080] text-[1.6rem]" />
            </a>
            <a
              href="https://twitter.com/i/flow/login?redirect_after_login=ElchemyHQ"
              target="_blank"
            >
              <TwitterIcon className="text-[#808080] text-[1.6rem]" />
            </a>
            <a
              href="https://www.linkedin.com/company/elchemyinternational/"
              target="_blank"
            >
              <LinkedInIcon className="text-[#808080] text-[1.6rem]" />
            </a>
             <a href="https://www.facebook.com/ElchemyHQ/" target="_blank">
              <FacebookRoundedIcon className="text-[#808080] text-[1.6rem]" />
            </a> */}
            <span className="w-6">
              <WhatsappShareButton
                url={`${process.env.NEXT_PUBLIC_APP_URL}${router.asPath}`}
              >
                <WhatsAppIcon className="text-[#808080] text-[1.6rem]" />
              </WhatsappShareButton>
            </span>
            <span className="w-6">
              <TwitterShareButton
                url={`${process.env.NEXT_PUBLIC_APP_URL}${router.asPath}`}
              >
                <TwitterIcon className="text-[#808080] text-[1.6rem]" />
              </TwitterShareButton>
            </span>
            <span className="w-6">
              <LinkedinShareButton
                url={`${process.env.NEXT_PUBLIC_APP_URL}${router.asPath}`}
              >
                <LinkedInIcon className="text-[#808080] text-[1.6rem]" />
              </LinkedinShareButton>
            </span>
            <span className="w-6">
              <FacebookShareButton
                url={`${process.env.NEXT_PUBLIC_APP_URL}${router.asPath}`}
              >
                <FacebookRoundedIcon className="text-[#808080] text-[1.6rem]" />
              </FacebookShareButton>
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default IndiividualInsightsFirstSection;
